import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OverlappingAbsence } from './useFetchOverlappingAbsences';
import { Row, Col } from 'react-bootstrap';
import AbsenceStatus from '../../pages/Absences/components/AbsenceStatus';
import AbsenceName from '../../pages/Absences/components/AbsenceName';
import LightList from '../LightList';
import MultiDayAbsenceBtn from '../../pages/Absences/components/MultiDayAbsenceDetails/MultiDayAbsenceBtn';
import { isMultiDayAndHourly } from '../../pages/Absences/components/MultiDayAbsenceDetails/logic';
import MultiDayAbsenceDetails from '../../pages/Absences/components/MultiDayAbsenceDetails';

type Props = {
  absences: readonly OverlappingAbsence[];
  loading: boolean;
  message?: string;
};

const OverlappingAbsences: React.FC<React.PropsWithChildren<Props>> = ({
  absences,
  loading,
  message,
}) => {
  const { t } = useTranslation();
  const [selectedAbsenceId, setSelectedAbsenceId] = useState<string>('');

  if (loading) {
    return <></>;
  }

  const handleCloseSidebar = () => {
    setSelectedAbsenceId('');
  };

  const listItems = absences.map((a) => {
    let name = <AbsenceName absence={a} />;

    if (isMultiDayAndHourly(a)) {
      name = (
        <>
          {name}{' '}
          <MultiDayAbsenceBtn absenceId={a.Id} onClick={setSelectedAbsenceId} />
        </>
      );
    }

    return {
      key: a.Id,
      name,
      value: <AbsenceStatus status={a.flair__Approval_Status__c} textFirst />,
    };
  });

  return (
    <>
      <Row>
        <Col>
          {message && <div className="mb-2">{message}</div>}
          <span className="h5">
            {t('requestAbsence.overlappingAbsences_interval', {
              postProcess: 'interval',
              count: absences.length,
            })}
          </span>

          <LightList items={listItems} itemsToShow={10} />
        </Col>
      </Row>

      {selectedAbsenceId && (
        <MultiDayAbsenceDetails
          absenceId={selectedAbsenceId}
          show={Boolean(selectedAbsenceId)}
          onClose={handleCloseSidebar}
        />
      )}
    </>
  );
};

export default OverlappingAbsences;
